module.exports = __webpack_public_path__ + "img/a5 افقی.570ae8df.jpg";